import { useOutsideClick } from 'components/hooks/useOutsideClick'
import Loading from 'components/loading'
import { IRetryDetail } from 'pages/agency-group-management/interface'
import React, { useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { headerAgencyActivityDetailTable } from './header'

interface Props {
  retryDetails: IRetryDetail[]
  isLoading: boolean
  hasMoreData: boolean
  handleRefetch: () => void
  handleFetchMore: () => void
}

const DetailAgencyActivityTable: React.FC<Props> = ({
  retryDetails,
  isLoading,
  handleFetchMore,
  handleRefetch,
  hasMoreData,
}) => {
  const [currentRowSelected, setCurrentRowSelected] = useState<IRetryDetail>()
  const [isShowAction, setIsShowAction] = useState<boolean>(false)

  const onHandleClickShowAction = (rowItem: IRetryDetail) => {
    setIsShowAction(true)
    setCurrentRowSelected(rowItem)
  }

  const onClickRetryBtn = (data: IRetryDetail) => {
    alert('click retry')
  }

  const ref = useOutsideClick(() => {
    setIsShowAction(false)
  })

  return (
    <div>
      <table className="w-full text-left border-2 border-neutral-6 rounded-t-lg overflow-hidden">
        <thead className="bg-primary-shade4 text-body1 text-neutral-2 md:pr-4">
          <tr>
            {headerAgencyActivityDetailTable.map((item: any, idx) => (
              <th key={idx} className={item.headerStyles}>
                <div className={`flex `}>
                  <span className={`${item.isOneLineRes && 'lg:mt-[-3.5px]'}`}>{item.name}</span>
                  <div className={`${item.isOneLineRes && 'lg:mt-[-3.5px]'}`}></div>
                </div>
              </th>
            ))}
          </tr>
        </thead>
      </table>

      {isLoading && <Loading className="relative py-6" height={30} width={30} />}

      {!retryDetails || retryDetails.length === 0 || isLoading ? (
        <p className="py-6 text-center text-body1 text-neutral-4">No data available.</p>
      ) : (
        <InfiniteScroll
          dataLength={retryDetails.length ?? 0}
          next={handleFetchMore}
          hasMore={hasMoreData}
          height={'max-content'}
          style={{ maxHeight: 300, minHeight: 200 }}
          loader={''}
          endMessage={''}
          className="cus-scrollbar"
        >
          {retryDetails?.map((data, index: number) => (
            <table key={index} className="cursor-pointer w-full">
              <tbody>
                <tr className="h-[72px] w-full hover:bg-neutral-7 pt-5">
                  <td className={` ${headerAgencyActivityDetailTable[0].rowWid}`}>
                    <div>
                      <span>{data.retry_number}</span>
                    </div>
                  </td>
                  <td className={`${headerAgencyActivityDetailTable[1].rowWid}`}>
                    <div>
                      <span>{data.status}</span>
                    </div>
                  </td>
                  <td className={`${headerAgencyActivityDetailTable[2].rowWid}`}>
                    <div>
                      <span>{data.is_processed.toString()}</span>
                    </div>
                  </td>
                  <td className={`${headerAgencyActivityDetailTable[3].rowWid}`}>
                    <div>
                      <span>{data.error}</span>
                    </div>
                  </td>
                  <td className={`${headerAgencyActivityDetailTable[4].rowWid}`}>
                    <div>
                      <span>{data.created_at}</span>
                    </div>
                  </td>
                  <td className={`${headerAgencyActivityDetailTable[5].rowWid}`}>
                    <div>
                      <span>{data.next_retry_second}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          ))}
        </InfiniteScroll>
      )}
    </div>
  )
}

export default DetailAgencyActivityTable
